import { useState, useEffect, createContext, useContext } from 'react';
import useWindowResize from 'proj/hooks/useWindowResize';
import * as IO from 'js/core/io';

import { GridSize, Mode, Breakpoint } from 'js/const';
import CNNTracker from 'js/proj/mod/cnnix-tracker';

const socialProvider = window.CNNSocial ? new CNNSocial() : null;
const tracker = new CNNTracker('cnnix-lbb');

const GlobalContext = createContext();

export const GlobalProvider = (props) =>
{
    // Interactive states
    const   [ data, setData ] =         useState(null),
            [ mode, setMode ] =         useState(null),
            [ store, setStore ] =       useState(null),
            [ active, setActive ] =     useState(null),
            [ menuOpen, setMenuOpen ] = useState(false);
    
    // Custom hooks
    const dimensions = useWindowResize({ debounce: 150 });

    //  Methods
    // -------------

    const getMode = () =>
    {
        switch(Breakpoint())
        {
            case GridSize.XS : case GridSize.SM :
                if(mode != Mode.MOBILE) return Mode.MOBILE;
                break;

            case GridSize.MD :
                if(mode != Mode.TABLET) return Mode.TABLET;
                break;

            case GridSize.LG : case GridSize.XL :
                if(mode != Mode.DESKTOP) return Mode.DESKTOP;
                break;

            default :
                break;
        }
    }

    const loadJSON = url => new Promise((resolve, reject) =>
        IO.Get(url,
        {
            success: response => response.currentTarget.responseText
                ? resolve(JSON.parse(response.currentTarget.responseText))
                : reject({ "message" : "Data could not be loaded", response }),
            error: reject
        } , true)
    );

    //  useEffects
    // ------------

    // Mode managment

    useEffect(() =>
    {
        let currentMode;
        currentMode != getMode() && setMode(getMode());
        currentMode = getMode();

        return () => { currentMode = null; };
    }, [dimensions]);

    // Init

    useEffect(() =>
    {
        // Window init
        window.CNN = window.CNN || {};
        // window.CNN.contentModel = window.CNN.contentModel || {};
        // window.CNN.contentModel.techStack = 'coolReactTestApp_1.0';
        return () => {};
    }, [])

    //  Provider
    // ------------

    return <GlobalContext.Provider
                value={{
                    mode, setMode,
                    store, setStore,
                    active, setActive,
                    menuOpen, setMenuOpen,

                    data, setData, loadJSON,

                    dimensions, tracker, socialProvider,
                }}>
                {props.children}
            </GlobalContext.Provider>
};

export default GlobalContext;